var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackErrorCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#E72D38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8828 11.4214L17.0001 15.5387L21.0961 11.4427C21.1866 11.3464 21.2956 11.2694 21.4166 11.2162C21.5376 11.163 21.668 11.1349 21.8001 11.1334C22.083 11.1334 22.3543 11.2457 22.5544 11.4458C22.7544 11.6458 22.8668 11.9171 22.8668 12.2C22.8693 12.3308 22.845 12.4607 22.7955 12.5818C22.746 12.7028 22.6722 12.8125 22.5788 12.904L18.4295 17L22.5788 21.1494C22.7546 21.3214 22.8577 21.5543 22.8668 21.8C22.8668 22.0829 22.7544 22.3542 22.5544 22.5543C22.3543 22.7543 22.083 22.8667 21.8001 22.8667C21.6642 22.8723 21.5286 22.8496 21.4019 22.8001C21.2752 22.7505 21.1602 22.6751 21.0641 22.5787L17.0001 18.4614L12.8935 22.568C12.8033 22.6611 12.6957 22.7354 12.5767 22.7867C12.4577 22.838 12.3297 22.8652 12.2001 22.8667C11.9172 22.8667 11.6459 22.7543 11.4459 22.5543C11.2459 22.3542 11.1335 22.0829 11.1335 21.8C11.131 21.6693 11.1553 21.5393 11.2048 21.4183C11.2543 21.2972 11.328 21.1876 11.4215 21.096L15.5708 17L11.4215 12.8507C11.2457 12.6787 11.1426 12.4458 11.1335 12.2C11.1335 11.9171 11.2459 11.6458 11.4459 11.4458C11.6459 11.2457 11.9172 11.1334 12.2001 11.1334C12.4561 11.1366 12.7015 11.24 12.8828 11.4214Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackErrorCrossRed);
export default __webpack_public_path__ + "static/media/feedback-error-cross-red.3c2e97fb23d8b086e9db6de8315ceb11.svg";
export { ForwardRef as ReactComponent };